import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import FileSelectCard from '../../cards/FileSelectCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const FileSelectCardWidget = (props) => {
    const component = useMemo(() => props.user ? (_jsx(FileSelectCard, { actions: [], matchedPrimary: props.user, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions })) : (_jsx(_Fragment, {})), [props.user]);
    return {
        name: 'FileSelectCard',
        category: 'composite',
        component,
    };
};
